import config from '../../../config';

export const baseEndpoint = `${config.baseUrl}/products/extract`;
